import { api_call } from '@/WebHandler/api_call'
import { proxy_api_call } from '@/WebHandler/proxy_api_call'
import { templateEncryptDataWithAES } from 'constant/functions'

// Save
export default async ({
  configs_data, //this should bé an array
  delete_configs_keys, // this should be a string
  setIsLoading,
  domain_id,
}) => {
  setIsLoading && setIsLoading(true)

  //
  let config_data_list = {
    configs: [...configs_data],
  }

  if (domain_id) {
    config_data_list.domain_id = domain_id
  }

  try {
    const save_result = await proxy_api_call({
      method: 'POST',
      path: `/api/configs`,
      data: templateEncryptDataWithAES(JSON.stringify(config_data_list)),
      onSuccess: (resp) => {
        return resp
      },
      onError: (error) => {
        return error
      },
    })
    const delete_result =
      delete_configs_keys?.length === 0
        ? {}
        : await api_call({
            method: 'DELETE',
            path: `/v1/configs?key=${delete_configs_keys}`,
            data: {},
            onSuccess: (response) => {
              return response
            },
            onError: (error) => {
              // Not returning the error , because there have posibolity that key is not avaialable itself
              return {}
            },
          })

    setIsLoading && setIsLoading(false)
    return { save_result, delete_result }
  } catch (error) {
    setIsLoading && setIsLoading(false)
    return error
  }
}
